import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const token = typeof window !== "undefined" ? localStorage.getItem("rescape_token") : null;

  // While bootstrapping OR while we have a token but the user context hasn't
  // synced yet (race between login() → setUser() and navigate("/app")), show
  // a loader instead of bouncing back to /connexion.
  if (loading || user === null || (token && !user)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  return children;
}
